import {Types} from './actions';
import initialState from './initialState';
import ReducerBuilder from "classes/ReducerBuilder";

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.START_PUBLISH_CHALLENGE)
    .reduce((state, action) => {
        state.publishingChallenge = true;
        state.platformsBeingPublished = action.platforms;
        state.successful = null;
    })
    .forType(Types.END_PUBLISH_CHALLENGE)
    .reduce((state, action) => {
        state.publishingChallenge = false;
        state.platformsBeingPublished = [];
    })
    .forType(Types.ERROR_PUBLISHING_CHALLENGE)
    .reduce((state, action) => {
      state.publishingChallenge = false;
      state.platformsBeingPublished = [];
    })
    .forType(Types.SHOW_PUBLISH_CHALLENGE_STATUS_MODAL)
    .reduce((state,action) => {
      state.showPublishChallengeStatusModal = true;
      state.successful = action.successful;
      if ( action.validationErrors !== null ) {
        state.validationErrors = action.validationErrors;
      }
    })
    .forType(Types.HIDE_PUBLISH_CHALLENGE_STATUS_MODAL)
    .reduce((state, action) => {
      state.showPublishChallengeStatusModal = false;
      state.validationErrors = null;  // reset on close
      state.successful = null;
    })
    /*
        Unpublish
     */
    .forType(Types.START_UNPUBLISH_CHALLENGE)
    .reduce((state, action) => {
        state.unpublishingChallenge = true;
        state.challengeBeingUnpublished = action.challenge;
        state.unpublishingChallengePending = false;
        state.platformsBeingUnpublished = action.platforms;
        state.unpublishingChallengeId = action.challengeId;
        state.unpublishingChallengeBreak = action.brk;
        state.successful = null;
    })
    .forType(Types.SUBMIT_UNPUBLISH_CHALLENGE)
    .reduce((state) => {
        state.unpublishingChallengePending = true;
    })
    .forType(Types.END_UNPUBLISH_CHALLENGE)
    .reduce((state, action) => {
        state.unpublishingChallenge = false;
        state.unpublishingChallengePending = false;
        state.platformsBeingUnpublished = [];
        state.unpublishingChallengeId = null;
        state.unpublishingChallengeBreak = null;
    })
    .forType(Types.ERROR_UNPUBLISHING_CHALLENGE)
    .reduce((state, action) => {
        state.unpublishingChallenge = false;
        state.platformsBeingUnpublished = [];
    })
    .forType(Types.SHOW_UNPUBLISH_CHALLENGE_STATUS_MODAL)
    .reduce((state,action) => {
        state.showUnpublishChallengeStatusModal = true;
        state.successful = action.successful;
        if ( action.validationErrors !== null ) {
            state.validationErrors = action.validationErrors;
        }
    })
    .forType(Types.HIDE_UNPUBLISH_CHALLENGE_STATUS_MODAL)
    .reduce((state, action) => {
        state.showUnpublishChallengeStatusModal = false;
        state.validationErrors = null;  // reset on close
        state.successful = null;
    })
    /*
        Validation
     */
    .forType(Types.START_VALIDATE_CHALLENGE_ACTION)
    .reduce((state,action) => {
      state.validatingChallenge = true;
      state.platformsBeingValidated = action.platforms;
      state.successful = null;
    })
    .forType(Types.END_VALIDATE_CHALLENGE)
    .reduce((state, action) => {
        state.validatingChallenge = false;
        state.platformsBeingValidated = [];
    })
    .forType(Types.ERROR_VALIDATING_CHALLENGE)
    .reduce((state, action) => {
      state.validatingChallenge = false;
      state.platformsBeingValidated = [];
    })
    .forType(Types.SHOW_VALIDATE_CHALLENGE_STATUS_MODAL)
    .reduce((state,action) => {
      state.showValidateChallengeStatusModal = true;
      state.successful = action.successful;
      if ( action.validationErrors !== null ) {
        state.validationErrors = action.validationErrors;
      }
    })
    // Close the publish challenge modal
    .forType(Types.HIDE_VALIDATE_CHALLENGE_STATUS_MODAL)
    .reduce((state, action) => {
      state.showValidateChallengeStatusModal = false;
      state.validationErrors = null;  // reset on close
      state.successful = null;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/BreakPublish/reducer.js